export default "__VITE_ASSET__DZOwIw$G__"